// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  name: 'dev',
  production: false,
  region: 'NA',
  appUrl: 'manage-zones.dev.zonarsystems.net',
  apiBase: {
    url: 'https://api.zonarsystems.net/core/v1/settings',
  },
  coreEntityApiBase: {
    url: 'https://api-dev.zonarsystems.net/core/v1',
  },
  userPreferenceApiBase: {
    url: 'https://api-dev.zonarsystems.net/alert/v1',
  },
  authEnv: 'development',
  auth: {
    clientID: 'lfP4OpIUCZhSoyINNbtAXPKlBx8WKyEN',
    domain: 'zonar-dev.auth0.com',
    audience: 'http://apidev.zonarsystems.net/',
    applicationId: '55c80b65-83d3-4257-ab47-323a3d687fa7',
    defaultZonarRole: '2301b839-48e1-4eab-b447-013b25038fe9',
    useRefreshTokens: true,
  },
  pendo: {
    url: 'https://cdn.pendo.io/agent/static/',
    key: '47e63a49-4477-47c2-4ea6-0f032e1785d5',
  },
  googleTagManager: {
    id: 'GTM-PM9R42P',
    auth: '4-KiGGwpt35kxwSPey_o-w',
    environment: 'env-3',
  },
  googleOptimize: {
    gOptId: null,
    powerOnAbTestId: null,
  },
  datadog: {
    enabled: true,
    applicationId: 'c600f2b7-494c-4e18-afc6-439707bcc61c',
    clientToken: 'pub9209625fca6265b4ba1bae7620e0f7b4',
    siteUrl: 'us5.datadoghq.com',
    tagEnvironment: 'development',
  },
  i18n: {
    supportedLanguages: ['en', 'en-GB', 'de', 'es', 'fr', 'it'],
    defaultLanguage: 'en',
  },
  devCycle: {
    clientId: 'dvc_client_e53775ea_d05c_484a_adc6_80e4d946ff92_be0127b',
  },
  apiKeyV3: 'K9sFEK271qD8JFibP_1Dk9u2IQqiTXsxsv9T11PaKng',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
